// extracted by mini-css-extract-plugin
export default {"hotkey":"Hotkeys_hotkey__QCGlT","key":"Hotkeys_key__EQj0N","description":"Hotkeys_description__bzZih"};